export default __webpack_public_path__ + "static/media/icon_star_idle_yellow.ada0d7b1.svg";